import React, { useState, useEffect } from 'react';

const ContactSection = ({ siteData, updateSiteData, setSiteData, showSaveStatus }) => {
    const [localContact, setLocalContact] = useState(siteData.contact);
    const [hasChanges, setHasChanges] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setLocalContact(siteData.contact);
        setHasChanges(false);
    }, [siteData.contact]);

    const handleLocalUpdate = (field, value) => {
        setLocalContact(prev => ({
            ...prev,
            [field]: value
        }));
        setHasChanges(true);
    };

    const handleSave = async () => {
        try {
            setSaving(true);
            setSiteData(prev => ({
                ...prev,
                contact: localContact
            }));

            await updateSiteData('contact', localContact);
            showSaveStatus('Contact information updated successfully!');
            setHasChanges(false);
        } catch (error) {
            console.error('Failed to update contact:', error);
            showSaveStatus('Failed to update contact information', true);
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center">
                <h3 className="text-xl font-semibold text-stone-800">Contact Information</h3>
                <button
                    onClick={handleSave}
                    disabled={!hasChanges || saving}
                    className={`px-6 py-2 rounded-lg font-medium transition-colors ${hasChanges && !saving
                        ? 'bg-amber-500 text-white hover:bg-amber-600'
                        : 'bg-stone-300 text-stone-500 cursor-not-allowed'
                        }`}
                >
                    {saving ? 'Saving...' : hasChanges ? 'Save Changes' : 'No Changes'}
                </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <label className="block text-sm font-medium text-stone-700 mb-2">Phone</label>
                    <input
                        type="text"
                        value={localContact.phone}
                        onChange={(e) => handleLocalUpdate('phone', e.target.value)}
                        className="w-full px-4 py-3 border border-stone-300 rounded-lg focus:ring-2 focus:ring-amber-400 focus:border-transparent"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-stone-700 mb-2">Email</label>
                    <input
                        type="email"
                        value={localContact.email}
                        onChange={(e) => handleLocalUpdate('email', e.target.value)}
                        className="w-full px-4 py-3 border border-stone-300 rounded-lg focus:ring-2 focus:ring-amber-400 focus:border-transparent"
                    />
                </div>
            </div>

            <div>
                <label className="block text-sm font-medium text-stone-700 mb-2">Address</label>
                <input
                    type="text"
                    value={localContact.address}
                    onChange={(e) => handleLocalUpdate('address', e.target.value)}
                    className="w-full px-4 py-3 border border-stone-300 rounded-lg focus:ring-2 focus:ring-amber-400 focus:border-transparent"
                />
            </div>

            <div>
                <label className="block text-sm font-medium text-stone-700 mb-2">Office Hours</label>
                <input
                    type="text"
                    value={localContact.hours}
                    onChange={(e) => handleLocalUpdate('hours', e.target.value)}
                    className="w-full px-4 py-3 border border-stone-300 rounded-lg focus:ring-2 focus:ring-amber-400 focus:border-transparent"
                />
            </div>
        </div>
    );
};

export default ContactSection;